import { withRouter } from "react-router-dom";

import { darken } from "@mui/material";
import Grid from "@mui/material/Grid";
import { useTheme } from "@mui/material/styles";

import Portal from "../ui/portal";
import PortalAppBar from "../ui/portalAppBar";
import PortalGridContent from "../ui/portalGridContent";
import BotpressProducts from "../widgets/botpressProducts";
import BotpressSiteMap from "../widgets/botpressSiteMap";
import BotpressTribalKnowledge from "../widgets/botpressTribalKnowledge";

const BotpressAdminPortal = props => {
  const theme = useTheme();

  return (
    <Portal
      displayHeader={false}
      sx={{
        backgroundSize: "cover",
        backgroundColor: darken(theme.palette.commonground.main, 0.4),
      }}
    >
      <PortalAppBar title="Botpress Admin Portal" botpressStyle={true} />
      <PortalGridContent>
        <Grid size={{ xs: 12 }}>
          <BotpressProducts minHeight={"0px"} />
        </Grid>

        <Grid size={{ xs: 12 }}>
          <BotpressSiteMap minHeight={"0px"} />
        </Grid>

        <Grid size={{ xs: 12 }}>
          <BotpressTribalKnowledge minHeight={"0px"} />
        </Grid>

        <Grid size={{ xs: 12, sm: 6, lg: 4 }} />
      </PortalGridContent>
    </Portal>
  );
};

export default withRouter(BotpressAdminPortal);
